import { Controller } from '@hotwired/stimulus';
import { openImage } from './modal_controller';

export default class extends Controller {
  static targets = ['image', 'resize', 'full', 'rotateright', 'rotateleft'];

  ctrls;
  ctrlLeft;
  ctrlRight;
  ctrlBigger;
  ctrlFull;

  connect() {
    // console.log("Hello from Image Controller")
    window.imageController = this;
    this.addControls();
  }

  image() {
    return this.element.querySelector('img');
  }

  toggleSize() {
    if (this.image().style.maxHeight === '1000px') {
      this.resizeSmaller();
    } else {
      this.resizeBigger();
    }
  }

  resizeBigger() {
    this.image().style.maxWidth = null;
    this.image().style.maxHeight = '1000px';

    this.adjustWrapperSize();
  }

  resizeSmaller() {
    this.image().style.maxWidth = '300px';
    this.image().style.maxHeight = '300px';
    this.adjustWrapperSize();
  }

  fullscreen() {
    const cloned = this.image().cloneNode();
    cloned.style.maxWidth = null;
    cloned.style.maxHeight = null;
    openImage(cloned);
  }

  rotation = 0;
  rotationClasses = ['rotate-0', 'rotate-90', 'rotate-180', '-rotate-90'];

  rotateRight() {
    this.rotation += 1;
    this.applyRotation();
  }

  rotateLeft() {
    this.rotation -= 1;
    this.applyRotation();
  }

  adjustWrapperSize() {
    if (this.rotation % 2 === 0) {
      // this.element.style.width = this.image().clientWidth + "px";
      this.element.style.height = this.image().clientHeight + 'px';

      // console.log("this.image().clientWidth " + this.image().clientWidth)
      // console.log("this.element.style.width " + this.element.style.width)
      // console.log("this.image().clientHeight " + this.image().clientHeight)
      // console.log("this.element.style.height " + this.element.style.height)
    } else {
      this.element.style.height = this.image().clientWidth + 'px';
      // this.element.style.width = this.image().clientHeight + "px";

      // console.log("this.image().clientWidth " + this.image().clientWidth)
      // console.log("this.element.style.width " + this.element.style.width)
      // console.log("this.image().clientHeight " + this.image().clientHeight)
      // console.log("this.element.style.height " + this.element.style.height)
    }
    switch (this.rotation) {
      case 0:
        this.image().style.left = null;
        this.image().style.top = null;
        break;
      case 1:
        this.image().style.left = this.image().clientHeight + 'px';
        this.image().style.top = null;
        break;
      case 2:
        this.image().style.left = this.image().clientWidth + 'px';
        this.image().style.top = this.image().clientHeight + 'px';
        break;
      case 3:
        this.image().style.left = null;
        this.image().style.top = this.image().clientWidth + 'px';
        break;
    }
  }

  addControls() {
    this.element.classList.add('relative');

    this.image().classList.add('origin-top-left', 'relative');

    this.ctrls = document.createElement('div');
    this.ctrls.classList.add(
      'absolute',
      'top-0',
      'left-0',
      'px-2',
      'py-1',
      'bg-white',
      'opacity-50',
      'hover:opacity-100',
      'flex',
      'flex-row',
      'gap-x-2',
      'font-mono',
      'text-bold',
      'inline-block'
    );

    this.ctrlLeft = document.createElement('span');
    this.ctrlLeft.classList.add('p-1', 'hover:text-primary', 'align-top', 'inline');
    this.ctrlLeft.textContent = '↶';
    this.ctrlLeft.addEventListener('click', this.rotateLeft.bind(this));
    this.ctrls.appendChild(this.ctrlLeft);

    this.ctrlRight = document.createElement('span');
    this.ctrlRight.classList.add('p-1', 'hover:text-primary', 'align-top', 'inline');
    this.ctrlRight.textContent = '↷';
    this.ctrlRight.addEventListener('click', this.rotateRight.bind(this));
    this.ctrls.appendChild(this.ctrlRight);

    this.ctrlBigger = document.createElement('span');
    this.ctrlBigger.classList.add('p-1', 'hover:text-primary', 'align-top', 'inline');
    this.ctrlBigger.textContent = '⌕';
    this.ctrlBigger.addEventListener('click', this.toggleSize.bind(this));
    this.ctrls.appendChild(this.ctrlBigger);

    if (this.fullScreenAvailable()) {
      this.ctrlFull = document.createElement('span');
      this.ctrlFull.classList.add('p-1', 'hover:text-primary', 'align-top', 'inline');
      this.ctrlFull.textContent = '↗';
      this.ctrlFull.addEventListener('click', this.fullscreen.bind(this));
      this.ctrls.appendChild(this.ctrlFull);
    }

    this.element.appendChild(this.ctrls);
  }

  applyRotation() {
    if (this.rotation > 3) {
      this.rotation = 0;
    }
    if (this.rotation < 0) {
      this.rotation = 3;
    }
    // console.log("Rotation: " + this.rotation)
    this.rotationClasses.forEach((klass, idx) => {
      if (idx === this.rotation) {
        this.image().classList.add(klass);
      } else {
        this.image().classList.remove(klass);
      }
    });
    this.adjustWrapperSize();
  }

  fullScreenAvailable() {
    return !(document.getElementById('image_view') === null);
  }
}
